import { Box } from '@chakra-ui/react'
import React from 'react'
import { ParticipantTile } from './participant-tile'

export const PinnedTile = ({
  width,
  participantId,
  aspectRatio,
  setAspectRatio
}: {
  width: string | object
  participantId: string
  aspectRatio: number
  setAspectRatio: (aspectRatio: number) => void
}) => {
  return (
    <Box
      position="absolute"
      top="0px"
      right="0px"
      width={width}
      height="auto"
      borderRadius="8px"
      boxShadow="lg"
      zIndex={2}
      overflow="hidden"
    >
      <ParticipantTile
        participantId={participantId}
        aspectRatio={aspectRatio}
        setAspectRatio={setAspectRatio}
      />
    </Box>
  )
}
